import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OilBarrelIcon(props: IconProps) {
    return <Icon {...props} iconKey={"oil_barrel"}/>
}
